import { Component, signal, inject } from '@angular/core';
import { SiteNoticeService } from './services/site-notice.service';
import { TranslationService } from './services/translation.service';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { TranslatePipe } from './pipes/translate.pipe';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    HeaderComponent,
    TranslatePipe,
    RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  readonly notice = inject(SiteNoticeService).notice;
  readonly language = inject(TranslationService).currentLang;
  protected readonly title = signal('canitrack-next');
}
